export default {"src":"/_next/static/image/src/images/our-food/kale.2854b1daeade5902d245ef3782069099.svg","height":39,"width":73};